// src/api.js
// Thin client over the same-origin Netlify proxy (/api/e/*).
// sessionStorage caches the country list per language (client-side equivalent
// of the WP plugin's weekly transient).

const DEFAULT_API_BASE = 'https://requirements.visamundi.app/api';

function buildHeaders(key) {
  const h = {};
  if (key) h['X-Embed-Key'] = key;
  return h;
}

export async function fetchCountries({ apiBase = DEFAULT_API_BASE, language, key }) {
  const cacheKey = `vm-widget-countries-${language}`;
  try {
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) return JSON.parse(cached);
  } catch (_) {
    /* sessionStorage may be unavailable (private mode, sandboxed iframe) */
  }

  const url = `${apiBase}/e/countries?language=${encodeURIComponent(language)}`;
  const res = await fetch(url, { headers: buildHeaders(key) });
  if (!res.ok) throw new Error(`countries ${res.status}`);
  const json = await res.json();
  const countries = json?.data?.countries;
  if (!Array.isArray(countries)) throw new Error('countries: malformed response');

  try {
    sessionStorage.setItem(cacheKey, JSON.stringify(countries));
  } catch (_) {
    /* ignore quota / availability errors */
  }
  return countries;
}

export async function fetchRequirement({
  apiBase = DEFAULT_API_BASE,
  language,
  nationality,
  destination,
  key,
}) {
  const params = new URLSearchParams({ language, nationality, destination });
  const url = `${apiBase}/e/visa/requirements?${params.toString()}`;
  const res = await fetch(url, { headers: buildHeaders(key) });
  if (!res.ok) throw new Error(`requirements ${res.status}`);
  const json = await res.json();
  if (!json?.data) throw new Error('requirements: malformed response');
  return json.data;
}

export { DEFAULT_API_BASE };
